import { BOW, bowCharge, holdSpread, type WeaponStats } from "@eldrun/content";

/** O que o quadro decidiu: soltar (com quanto tempo de corda) ou seguir puxando. */
export interface BowFrame {
  /** Carga atual (0 a 1) para o anel da mira; 0 sem puxar. */
  charge: number;
  /** Abertura extra da mira (graus), por segurar demais. */
  spread: number;
  charging: boolean;
  /** Começou a puxar neste quadro (avisa o servidor, que mede a carga). */
  started?: boolean;
  /** Soltou neste quadro: tempo de corda em ms. */
  release?: number;
}

/**
 * Corda do arco no cliente (doc 02 §12): segurar a ação puxa, soltar atira. Um clique rápido entre
 * dois quadros (apertou e soltou antes de o quadro ver) também atira, sem carga. O servidor recalcula
 * a carga com o tempo que aceita; isto só alimenta a mira, o anel e a flecha prevista.
 */
export class BowString {
  private start: number | undefined;
  /** Rearme espelhado do servidor: antes disto não puxa nem atira. */
  private readyAt = 0;

  frame(bow: WeaponStats | undefined, down: boolean, clicked: boolean, canShoot: boolean, now: number): BowFrame {
    if (!bow || !canShoot) {
      this.start = undefined;
      return { charge: 0, spread: 0, charging: false };
    }
    if (now < this.readyAt) return { charge: 0, spread: 0, charging: false };
    if (down) {
      const started = this.start === undefined;
      this.start ??= now;
      const held = (now - this.start) / 1000;
      return { charge: bowCharge(bow, held), spread: holdSpread(bow, held), charging: true, started };
    }
    if (this.start !== undefined) {
      const release = now - this.start;
      this.start = undefined;
      this.readyAt = now + BOW.rearm * 1000;
      return { charge: 0, spread: 0, charging: false, release };
    }
    if (!clicked) return { charge: 0, spread: 0, charging: false };
    this.readyAt = now + BOW.rearm * 1000;
    return { charge: 0, spread: 0, charging: false, started: true, release: 0 };
  }

  /** Trocou de item: a puxada em andamento se perde (o servidor faz o mesmo). */
  cancel(): void {
    this.start = undefined;
  }

  get charging(): boolean {
    return this.start !== undefined;
  }
}
